import { TrackingTech } from '@sweetspot/shared/types'

export const trackingTechnologies = [TrackingTech.NONE, TrackingTech.TOPTRACER]

export const maxNrOfBulkBays = 99
